<template>
  <a :id="template.FileName + '_' + mediaClassification" :href="externalLink" target="new" :class="styleClasses" @contextmenu="contextMenu(template, $event)">
    <div class="item">
      <p :title="template.FileName" style="word-wrap: break-word">
        <strong>{{ template.FileName }}</strong>
      </p>
    </div>
  </a>
</template>
<script>
import popupUtils from '@/utils/popupUtils'
import config from '../../configurations/config.js'

export default {
  name: 'labCertificateBox',
  props: ['template', 'options'],
  data() {
    return {
      styleClasses: '',
      externalLink: '',
      mediaClassification: config.constants.MediaClassification.LabCertificates
    }
  },
  watch: {
    options: {
      immediate: true,
      deep: true,
      handler() {
        this.optionsChanged()
      }
    }
  },
  computed: {
    selectedElement: {
      set(value) {
        this.$store.commit('setSelectedElement', value)
      },
      get() {
        return this.$store.state.selectedElement
      }
    }
  },
  methods: {
    optionsChanged() {
      this.styleClasses = ''
      this.externalLink = ''
      let optionsObject = this.options || {}
      if (!optionsObject.externalLink || (optionsObject.externalLink && optionsObject.externalLink !== '')) {
        this.externalLink = `${optionsObject.externalLink}&preview=${encodeURIComponent(this.template.FileName)}`
      }

      if (optionsObject.enableBoxLink) {
        this.styleClasses += 'buttonClickEnabled'
      }
    },
    contextMenu: function (projectDocument, e) {
      this.selectedElement = {
        type: 'ATTACHMENT',
        id: 'attachement-' + projectDocument.FileName,
        fileName: projectDocument.FileName,
        mediaClassification: this.mediaClassification
      }

      popupUtils.popup(e, '#projectContextMenuPopup', { elementAnchor: 'rb', popupAnchor: 'cc' })
      e.preventDefault()
    }
  }
}
</script>
